<template>
	<div>
		<v-flex>
			<v-card class="card-inner-wrapper" :to="card_element.path">
				<div class="card-image">
					<img :src="card_element.image" alt />
				</div>
				<div class="card-title">{{ getStateWithParam(card_element.name) }}</div>
			</v-card>
		</v-flex>
	</div>
</template>

<script>
export default {
	props: {
		card_element: {
			type: Object,
			required: true,
		},
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss" scoped>
.flex {
	height: 100%;
	.card-inner-wrapper {
		background-color: white;
		border: 0;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
		border-radius: 10px;
		display: flex;
		justify-content: center;
		position: relative;
		padding: 15px;
		height: 170px;
		.card-image {
			width: 90%;
			text-align: right;
			img {
				//max-width: 100%;
				//width: auto;
				//max-height: 100%;
				//height: 100%;
				width: 100%;
				max-width: 180px;
				//height: 100px;
			}
		}
		.card-title {
			font-size: 16px;
			font-weight: 800;
			letter-spacing: 0.3px;
			color: #2b2b2b;
			position: absolute;
			bottom: 15px;
			left: 15px;
			line-height: 1.2;
		}
	}
}
</style>
